import { useTranslator } from 'tradera/lang/translate';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

export const SearchButton = ({ showSearch, onClick }) => {
    const { t } = useTranslator();

    return (
        <Button
            className="slim-header__button"
            round
            theme={showSearch ? 'highlight' : 'text'}
            aria-label={t('siteHeader_search')}
            title={t('siteHeader_search')}
            onClick={onClick}
            aria-hidden="true"
            icon={<SearchIcon className="icon icon-md" />}
        />
    );
};
